import { render } from "./AuthShell.vue?vue&type=template&id=05e6f541&scoped=true"
import script from "./AuthShell.vue?vue&type=script&lang=js"
export * from "./AuthShell.vue?vue&type=script&lang=js"

import "./AuthShell.vue?vue&type=style&index=0&id=05e6f541&scoped=true&lang=css"

import exportComponent from "/home/lino-guzman/code/descargas/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05e6f541"]])

export default __exports__